import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IdName} from '../../../models/id-name.model';
import {MenuItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {TieredMenu} from 'primeng/tieredmenu';
import {ToastService} from '../../../services/toast.service';
import {SiFile} from '../../../models/file.model';

@Component({
  selector: 'si-documentation-fields',
  templateUrl: './documentation-fields.component.html',
  styleUrls: ['./documentation-fields.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentationFieldsComponent implements OnInit {
  @ViewChild('tieredMenu') tieredMenu: TieredMenu;
  @ViewChild('tieredMenu2') tieredMenu2: TieredMenu;
  @ViewChild('tieredMenu3') tieredMenu3: TieredMenu;
  @ViewChild('tieredMenu4') tieredMenu4: TieredMenu;
  translationText = 'SI_HOME';
  showClickOutside = false;
  displayDialogSmall = false;
  displayDialogMedium = false;
  tieredMenuItems: MenuItem[];
  readModeFlag = false;
  disableFieldsFlag = false;
  inputModel: string;
  inputNumberModel: number;
  inputSwitchModel: boolean;
  multilineModel: string;
  richTextModel: string;
  checkModel: boolean;
  checkDynamicModel: number[] = [2];
  checkDynamicPathModel: IdName[];
  datepickerFromModel: number;
  datepickerToModel: number;
  datepickerTimeModel: number;
  radioModel: number;
  radioButtonModel1: number;
  radioButtonModel2: number;
  radioDynamicModel: IdName;
  radioDynamicModel2: number;
  selectorValuesModel: IdName;
  selectorInput: IdName | string = 'ITEM1';
  selectorOutput: IdName | number;
  selectorInputOutput: string | number = 'ITEM2';
  selectorModel: IdName;
  selectorBackSearchModel: IdName;
  selectorTemplateModel: IdName;
  selectorWithButtonsModel: IdName;
  selectorWithoutSearchModel: IdName;
  selectorValues: IdName[] = [
    {id: 1, name: 'Item 1', code: 'ITEM1'}, {id: 2, name: 'Item 2', code: 'ITEM2'}
  ];
  selectorMultipleValuesModel: IdName[] | number[];
  selectorMultipleInput: IdName[] | string[] = ['ITEM1'];
  selectorMultipleOutput: IdName[] | number[];
  selectorMultipleInputOutput: string[] | number[] = ['ITEM2'];
  selectorMultipleModel: IdName[];
  selectorMultipleBackSearchModel: IdName[];
  selectorMultipleTemplateModel: IdName[];
  selectorDialogModel: IdName;
  selectorDialogInternalModel1: IdName;
  selectorDialogInternalModel2: IdName;
  displaySelectorDialog = false;
  selectorMultipleDetailModel: IdName[];
  uploadedFiles = [];
  uploadedFilesMultiple = [];
  uploadedFilesMultipleWithFiles = [
    {
      id: 1,
      name: 'File with url.pdf',
      url: 'https://www.boe.es/boe/dias/2019/07/04/pdfs/BOE-A-2019-9974.pdf',
      type: 'application/pdf'
    },
    {
      id: 2,
      name: 'File with fileId.svg',
      fileId: 'select_arrow.svg',
      type: 'image/svg+xml'
    }
  ] as SiFile[];

  constructor(
    private translateService: TranslateService,
    private toastService: ToastService
  ) {
  }

  ngOnInit(): void {
    this.setTieredMenuItems();
  }

  async setTieredMenuItems(): Promise<void> {
    const testText = await this.translateService.get('SI_HOME').toPromise();
    const mockModuleText = this.translateService.instant('SI_MOCK_MODULE');
    const mockComponentText = this.translateService.instant('SI_MOCK_COMPONENT');
    const coreText = this.translateService.instant('CORE_CORE');
    const documentationText = this.translateService.instant('CORE_DOCUMENTATION');

    this.tieredMenuItems = [
      {
        label: testText,
        icon: 'icon-home',
        routerLink: '/',
        command: () => this.closeMenu()
      },
      {
        label: mockModuleText,
        icon: 'icon-style',
        items: [
          {label: mockComponentText, icon: '', command: () => this.closeMenu()}
        ]
      },
      {
        label: coreText,
        icon: 'icon-book',
        items: [
          {label: documentationText, icon: '', command: () => this.closeMenu()}
        ]
      }
    ];
  }

  closeMenu(): void {
    this.tieredMenu.hide();
    this.tieredMenu2.hide();
    this.tieredMenu3.hide();
    this.tieredMenu4.hide();
  }

  onClickOutsideDirective(): void {
    this.showClickOutside = !this.showClickOutside;
  }

  onClickOpenDialogSmall(): void {
    this.displayDialogSmall = true;
  }

  onClickOpenDialogMedium(): void {
    this.displayDialogMedium = true;
  }

  onClickCloseDialog(action: boolean): void {
    if (action) {
      console.log('Aceptar diálogo');
      // Accept functionality.
      // Emit the change: this.updateChange.emit();
    }

    this.displayDialogSmall = false;
    this.displayDialogMedium = false;
  }

  async showToastSuccess(): Promise<void> {
    await this.toastService.success('SI_HOME');
  }

  async showToastError(): Promise<void> {
    await this.toastService.error('SI_HOME');
  }

  async showToastInfo(): Promise<void> {
    await this.toastService.info('SI_HOME');
  }

  async showToastWarning(): Promise<void> {
    await this.toastService.warning('SI_HOME');
  }

  enableFields(enableFlag = true): void {
    this.readModeFlag = false;
    this.disableFieldsFlag = !enableFlag;
  }

  setReadMode(readModeFlag = false): void {
    this.readModeFlag = readModeFlag;
    this.disableFieldsFlag = readModeFlag;
  }

  onDisplaySelectorDialog(display: boolean): void {
    if (display) {
      delete this.selectorDialogInternalModel1;
      delete this.selectorDialogInternalModel2;
    }
  }

  onClickCloseSelectorDialog(action: boolean): void {
    if (action) {
      this.selectorDialogModel = this.selectorDialogInternalModel2;
    }

    this.displaySelectorDialog = false;
  }
}
